import { render, staticRenderFns } from "./SendDocumentModal.vue?vue&type=template&id=0fdcbf32&scoped=true&"
import script from "./SendDocumentModal.vue?vue&type=script&lang=js&"
export * from "./SendDocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./SendDocumentModal.vue?vue&type=style&index=0&id=0fdcbf32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdcbf32",
  null
  
)

export default component.exports